import axios from "axios";
const GOOGLE_MAPS_API_KEY = "AIzaSyBCHPq1PR4-GLt5yh9GXzflvmDfU-Ikmw4";

export const translateText = async (
  text: string | string[],
  targetLanguage: string
) => {
  const Axios = axios.create();

  Axios.defaults.baseURL = "";
  delete Axios.defaults.headers.common["Authorization"];

  const url = `https://translation.googleapis.com/language/translate/v2?key=${GOOGLE_MAPS_API_KEY}`;
  console.log("targetLanguage", targetLanguage);
  try {
    const response = await Axios.post(url, {
      q: text,
      target: targetLanguage,
    });
    if (Array.isArray(text)) {
      return response.data.data.translations.map(
        (translation: { translatedText: string }) => translation.translatedText
      );
    }
    return response.data.data.translations[0].translatedText;
  } catch (error) {
    console.error("Translation error: ", error);
    return null;
  }
};
